module.exports = __webpack_public_path__ + "static/media/logoLotear.86233f8c.png";